









































































































































































































































































import TabsInfoMixin from '@/pages/mapView/components/MapTabs/devices/TabsInfoMixin';
import Component from 'vue-class-component';
import { Mixins } from 'vue-mixin-decorator';
import { Prop, Watch } from 'vue-property-decorator';
import MapView from '@/views/MapView.vue';
import API, { Types } from '@/modules/API';
import { Reports, Global, Projects } from '@/store';
import Utils from '@/modules/Utils';
import DimmingDialog from '@/components/dialogs/DimmingDialog.vue';
import LoadingDialog from '@/components/dialogs/LoadingDialog.vue';
import CabinetScheduleDialog from '@/components/CabinetScheduleDialog.vue';
import { single_unit_alert_types, single_unit_probability_alert_types } from '@/store/modules/Global';
import { RETROFIT_STATE, PARTIAL_RETROFIT_STATE } from '@/modules/retrofitActions';
import vuex from '@/store';
// import * as Sentry from '@sentry/vue';

@Component({
  components: {
    MapView,
    DimmingDialog,
    LoadingDialog,
    CabinetScheduleDialog
  }
})
class FullViewTab extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
  // @ts-ignore
  @Prop() device;
  @Prop() deviceStreams;
  @Prop() cabinetDevices;
  @Prop() phasesLiveData;
  @Prop() closeBtn;

  @Global.State('readonly_user') readonly_user;
  @Global.State('disable_group_control') disable_group_control;
  @Global.State('lang') lang;
  @Global.State('timezone') projectTimezone;
  @Reports.State('reportsList') devices;
  @Reports.State('streamingComplete') streamingComplete;
  @Reports.Getter('commissionedFixtures') commissionedFixtures;
  @Reports.Getter('commissionedCabinets') commissionedCabinets;
  @Projects.State('projectAlerts') projectAlerts;

  loading = true;
  phases_live_data = {};
  events_history = [];
  Utils = Utils; // for getting access from template
  cabinetData: any = {};
  filteredDevices: string[] = [];
  filteredDevicesAmount: number = 0;
  filterType: string = '';
  secondaryFilter: string[] = [];
  phaseActive: string[] = [];
  phaseActiveAlerts: [];
  circuitActive: string[] = [];
  circuitActiveAlerts: [];
  totalAmount: number = 0;
  filterAlert: any[] = [];
  allDevicesFilter: any = {};
  alertDevicesFilter: any = {};
  showDevicesType: string = 'cabinet';
  unassignedPick: boolean = false;
  selectDevices: boolean = false;
  dimmingDialog: boolean = false;
  scheduleDialog: boolean = false;
  dimming_converting_table = null;
  converted: boolean = false;
  percentToDaliTable: any = null;
  loadingDialog: boolean = false;
  circuitTransform: any = null;
  circuitTransformSplited: any = null;
  circuitsPagination: number = 0;
  filter_menu = false;
  
  async mounted() {
    // await this.setCabinetEvents();
    this.filterType = 'all';
    this.getCabinetAlertsData();
    this.$store.commit('Global/setPageTitle', 'Cabinet Details');
    if (this.controlled_devices.length) {
      [this.converted, this.percentToDaliTable] =
        await Utils.convertDimmerValues(this.controlled_devices[0].id);
    }
    this.loading = false;
  }

  // Reactive so the lists stay correct while the project-wide
  // streaming_reporting_query is still loading fixtures in the background
  // (fixtures stream in after cabinets/hubs). Computing these once in mounted()
  // captured a partial snapshot — mostly cabinets — so 'Other Cabinet Devices'
  // showed only cabinets.
  get unassignedDevices(): string[] {
    return this.commissionedFixtures
      .filter((device) => !device['meta.device'].hasOwnProperty('cabinet_id') || device['meta.device'].cabinet_id === '')
      .map((device) => device.id);
  }

  get otherDevices(): string[] {
    if (!this.cabinetDevices.length) return [];
    const devicesAndCabinets = [...this.commissionedFixtures, ...this.commissionedCabinets];
    const current_cabinet_id = this.cabinetDevices[0]['meta.device'].cabinet_id;
    return devicesAndCabinets
      .filter(
        (device) =>
          device['meta.device'].hasOwnProperty('cabinet_id') &&
          device['meta.device'].cabinet_id !== '' &&
          device['meta.device'].cabinet_id !== current_cabinet_id
      ).map((device) => device.id);
  }

  isVirtualDevice(meta_device){
    return meta_device.fixture_icon ? meta_device.fixture_icon.toString().toLowerCase() === 'virtual' : false;
  }

  get devicesOnCount(){
    return this.cabinetDevices.filter((device) => !device.power && !this.isVirtualDevice(device['meta.device'])).length;
  }

  get devicesOffCount(){
    return this.cabinetDevices.filter((device) => device.power && !this.isVirtualDevice(device['meta.device'])).length;
  }

  isUnderRetrofit(device) {
    const operation_state = Utils.getOperationState(device);
    return operation_state === RETROFIT_STATE || operation_state === PARTIAL_RETROFIT_STATE;
  }

  // Only a cabinet in full Retrofit blocks group control:
  // - Partial Retrofit means just *some* fixtures are out, so the rest stay
  //   controllable and the retrofit ones are skipped.
  // - Pending Verification is not Retrofit - the cabinet has already been
  //   returned, and turning it on/off is exactly how it gets verified, so the
  //   buttons have to be usable again the moment the return completes.
  get cabinet_blocks_group_control() {
    return Utils.getOperationState(this.device) === RETROFIT_STATE;
  }

  // Devices out for Retrofit must never receive power commands, even when the
  // cabinet-wide button is used.
  get all_devices_under_retrofit() {
    if (this.cabinet_blocks_group_control) return true;
    return !!this.cabinetDevices.length &&
      this.cabinetDevices.every((device) => this.isUnderRetrofit(device));
  }

  get retrofit_block_reason() {
    return this.cabinet_blocks_group_control
      ? 'This cabinet is under Retrofit'
      : 'All devices of this cabinet are under Retrofit';
  }

  // A computed, not a `cabinetDevices` watcher: returning a device from
  // Retrofit only changes fields *inside* the row (operation state,
  // sys___active), which never re-fires an array watcher - the command targets
  // stayed frozen until the array identity happened to change.
  get controlled_devices() {
    return this.cabinetDevices.filter((device) =>
      device.sys___active && device.sys___connected && !this.isVirtualDevice(device['meta.device']) && !this.isUnderRetrofit(device)
    );
  }

  // Fixtures can still be streaming in from the project-wide
  // streaming_reporting_query after this tab has already mounted (fixtures
  // arrive after cabinets/hubs). Without this watcher, cabinetData.devices /
  // totalAmount / filteredDevicesAmount stay frozen at the mount-time
  // snapshot, causing a mismatch with the header's live actual_controlled_devices.
  // Passes resetFilter=false to preserve the user's active filter selection.
  @Watch('cabinetDevices')
  refreshCabinetAlertsData() {
    this.getCabinetAlertsData(false);
  }

  async setPowerLevel(power_percent) {
    this.loadingDialog = true;
    const dali_power = this.converted
      ? this.percentToDaliTable[power_percent]
      : Math.round((power_percent * 254) / 100);
    const slices = Math.ceil(this.controlled_devices.length / 5);
    let startIndex = 0,
      endIndex = Math.min(this.controlled_devices.length, 5);
    let failedDevices = 0;
    const totalDevices = this.controlled_devices.length;
    let notificationShown = false;
    
    const retrofitSkipped = this.cabinetDevices.filter((device) => this.isUnderRetrofit(device)).length;
    const retrofitNote = retrofitSkipped
      ? ` (${retrofitSkipped} ${this.$t('devices under Retrofit were skipped')})`
      : '';

    const showNotification = () => {
      if (notificationShown) return;
      
      notificationShown = true;
      this.loadingDialog = false;
      
      if (failedDevices === 0) {
        this.$store.dispatch('Global/throwNotify', {
          type: 'success',
          title: this.$t('Success'),
          text: `${this.$t('Command sent to all devices')}${retrofitNote}`
        });
      } else {
        this.$store.dispatch('Global/throwNotify', {
          type: 'error',
          title: this.$t('Error'),
          text: `Failed to send command to ${failedDevices} of ${totalDevices} devices${retrofitNote}`
        });
      }
    };

    try {
      for (let i = 0; i < slices; i++) {
        const current = this.controlled_devices.slice(startIndex, endIndex);
        await Promise.all(
          current.map(async (device) => {
            try {
              await this.updateDevicePower(device.id, dali_power);
              return true;
            } catch (e) {
              try {
                await this.updateDevicePower(device.id, dali_power);
                return true;
              } catch (e) {
                failedDevices++;
                return false;
              }
            }
          })
        );
        startIndex = endIndex;
        endIndex = Math.min(this.controlled_devices.length, endIndex + 5);
      }

      // All API calls completed, show notification immediately
      showNotification();
    } catch (error) {
      // In case of uncaught errors, rely on the timeout
    }

    // Keep the timeout as a fallback
    const timeoutId = setTimeout(() => {
      if (this.loadingDialog) {
        showNotification();
        console.warn(`setPowerLevel timeout`);
        // Sentry.captureMessage(`setPowerLevel timeout`);
      }
    }, 30000);
  }

  updateDevicePower(device_id, power) {
    return API.post(
      '',
      `${Types.PROJECTS}/${this.project.id}/${Types.DEVICES}/${device_id}/streams/power/cmd/`,
      { content: power },
      {},
      'v4'
    );
  }
  getCabinetAlertsData(resetFilter = true) {
    const cabinet_id = this.device['meta.device'].cabinet_id;
    this.totalAmount = this.cabinetDevices.length;
    const cabinet_alerts = this.projectAlerts.filter((incident) => incident.cabinet_id === cabinet_id);

    const all_alerts_types = single_unit_alert_types.concat(single_unit_probability_alert_types);
    const cabinet = {
      ...this.device,
      devices: this.cabinetDevices,
      alerts: cabinet_alerts.filter((incident) => incident.device_id && all_alerts_types.includes(incident.incident_type))
    };

    const devicesId = this.cabinetDevices.map((device) => device.id);
    const devicesAlerts = [
      ...new Set(
        cabinet.alerts
          .filter((incident) => devicesId.includes(incident.device_id))
          .map((incident) => incident.device_id)
      )
    ];
    this.filterAlert = devicesAlerts;

    const tempAllDevicesFilter = {R: [], S: [], T: []};
    const tempCircuits = cabinet.devices.filter((related_device) => related_device['meta.device'].hasOwnProperty('circuit_number'));
    const circuitList = [
      ...new Set(tempCircuits.map((dev) => dev['meta.device'].circuit_number))
    ]
      .sort((a, b) => (a > b ? 1 : -1))
      .filter((cir) => cir.toString().trim() !== '');
    const transformList = {};
    for (let i = 0; i < circuitList.length; i++) {
      tempAllDevicesFilter[`${i + 1}`] = [];
      transformList[`${i + 1}`] = circuitList[i];
    }
    this.circuitTransform = transformList;
    if (Object.keys(transformList).length > 6) {
      const circuitTransformSplited = Array(Math.ceil(Object.keys(transformList).length / 6));
      let i = 0;
      for (let index = 0; index < circuitTransformSplited.length; index++) {
        circuitTransformSplited[index] = {};
      }
      for (const iterator of Object.entries(transformList)) {
        circuitTransformSplited[i][`${iterator[0]}`] = iterator[1];
        if (Object.keys(circuitTransformSplited[i]).length === 6) {
          i++;
        }
      }
      this.circuitTransformSplited = circuitTransformSplited;
      this.circuitsPagination = 0;
    }
    for (const field in tempAllDevicesFilter) {
      if (['R', 'S', 'T'].indexOf(field) === -1) {
        tempAllDevicesFilter[field] = cabinet.devices
          .filter((device) => device['meta.device'].circuit_number === transformList[field])
          .map((dev) => dev.id);
      } else {
        tempAllDevicesFilter[field] = cabinet.devices
          .filter((device) => device['meta.device'].phase === field)
          .map((dev) => dev.id);
      }
    }

    this.allDevicesFilter = tempAllDevicesFilter;
    this.alertDevicesFilter = {R: [], S: [], T: []};
    for (let i = 0; i < circuitList.length; i++) {
      this.alertDevicesFilter[`${i + 1}`] = [];
    }
    for (const type in this.alertDevicesFilter) {
      this.alertDevicesFilter[type] = this.allDevicesFilter[type].filter(
        (device) => this.filterAlert.indexOf(device) > -1
      );
    }
    this.cabinetData = cabinet;
    if (resetFilter) {
      this.setMainFilter('all');
    }
    this.setFilteredDevices();
    this.filteredDevices = [...this.cabinetData.devices.map((device) => device.id), this.device.id];
  }

  setMainFilter(type) {
    this.filterType = type;
    vuex.commit('MapSettings/updateFilterType', type);
    this.secondaryFilter = [];
    if (type === 'all') {
      this.filteredDevicesAmount = this.totalAmount;
      this.filteredDevices = [...this.cabinetData.devices.map((device) => device.id), this.device.id];
    } else {
      this.filteredDevicesAmount = this.filterAlert.length;
      this.filteredDevices = [...this.filterAlert, this.device.id];
    }
  }

  setSecondFilterPhase(type) {
    if (this.secondaryFilter.indexOf(type) > -1) {
      this.secondaryFilter.splice(this.secondaryFilter.indexOf(type), 1);
    } else if (
      this.secondaryFilter.length === 0 ||
      this.secondaryFilter.indexOf('1') > -1 ||
      this.secondaryFilter.indexOf('2') > -1 ||
      this.secondaryFilter.indexOf('3') > -1 ||
      this.secondaryFilter.indexOf('4') > -1 ||
      this.secondaryFilter.indexOf('5') > -1 ||
      this.secondaryFilter.indexOf('6') > -1
    ) {
      this.secondaryFilter = [type];
    } else {
      this.secondaryFilter = [...this.secondaryFilter, type];
    }
    this.setFilteredDevices();
  }

  setSecondFilterCircuit(type) {
    if (this.secondaryFilter.indexOf(type) > -1) {
      this.secondaryFilter.splice(this.secondaryFilter.indexOf(type), 1);
    } else if (
      this.secondaryFilter.length === 0 ||
      this.secondaryFilter.indexOf('R') > -1 ||
      this.secondaryFilter.indexOf('S') > -1 ||
      this.secondaryFilter.indexOf('T') > -1
    ) {
      this.secondaryFilter = [type];
    } else {
      this.secondaryFilter = [...this.secondaryFilter, type];
    }
    this.setFilteredDevices();
  }

  // async setCabinetEvents() {
  //   const stream = { id: `${this.device.id}.sys___event` };
  //   this.events_history = await Utils.fetchSingleStreamHistory({
  //     device: this.device,
  //     stream,
  //     period: '1weeks'
  //   });
  //   this.events_history = this.events_history.filter(([timestamp, value]) => value !== 'pong');
  //   this.events_history = this.events_history.map(([timestamp, value]) => {
  //     const index = value.lastIndexOf('#');
  //     const msg = value.slice(index + 1, -1);
  //     return [timestamp, msg];
  //   });
  // }

  circuitBack(){
    this.circuitsPagination = this.circuitsPagination === 0
      ? this.circuitTransformSplited.length - 1
      : this.circuitsPagination - 1;
  }

  circuitNext(){
    this.circuitsPagination = this.circuitsPagination === this.circuitTransformSplited.length - 1
      ? 0
      : this.circuitsPagination + 1;
  }

  setFilteredDevices() {
    if (this.filterType === 'alerts' && this.secondaryFilter.length === 0) {
      this.filteredDevices = [...this.filterAlert, this.device.id];
      this.filteredDevicesAmount = this.filterAlert.length;
    }
    if (this.filterType === 'all' && this.secondaryFilter.length > 0) {
      let tempDevices = [this.device.id];
      for (const i of this.secondaryFilter) {
        tempDevices = [...tempDevices, ...this.allDevicesFilter[i]];
      }
      this.filteredDevicesAmount = tempDevices.length - 1;
      this.filteredDevices = tempDevices;
    } else if (this.filterType === 'all') {
      // No need to deep-clone the device objects just to read their ids.
      this.filteredDevicesAmount = this.cabinetData.devices.length;
      this.filteredDevices = [
        ...this.cabinetData.devices.map((device) => device.id),
        this.device.id
      ];
    }
    if (this.filterType === 'alerts' && this.secondaryFilter.length > 0) {
      let tempDevices = [this.device.id];
      for (const i of this.secondaryFilter) {
        tempDevices = [...tempDevices, ...this.alertDevicesFilter[i]];
      }
      this.filteredDevicesAmount = tempDevices.length - 1;
      this.filteredDevices = tempDevices;
    }
  }

  checkBadgeCount(sign, value, key){
    if (sign === '<'){
      return (this.filterType === 'all' && this.allDevicesFilter[key].length < value) 
        || (this.filterType !== 'all' && this.alertDevicesFilter[key].length < value);
    }
    return (this.filterType === 'all' && this.allDevicesFilter[key].length > value) 
      || (this.filterType !== 'all' && this.alertDevicesFilter[key].length > value);
  }

  @Watch('selectDevices')
  closeFilter(newVal) {
    if (!newVal) {
      this.showDevicesType = 'cabinet';
    }
  }
}

export default FullViewTab;

